export default __webpack_public_path__ + "success_icon.svg";